// extracted by mini-css-extract-plugin
export default {"chips_wrapper":"QFilters_chips_wrapper__B954-","chip":"QFilters_chip__77gNp","selected":"QFilters_selected__8u-+5"};